// JS for a group's public welcome page

// The share modal opens through Bootstrap's data attributes, so the modal js needs to be on the page
// eslint-disable-next-line no-unused-vars
import BootstrapModal from "bootstrap/js/dist/modal";

import { ShareOptions } from "./webcomponents/share-options.js";

// Register required webcomponents
ShareOptions.Register();
